import styles from "./PaywallsForm.module.scss";

const PaywallsGratitude = () => {
  return (
    <div className={styles.gratitude}>
      <h3 className={styles.gratitude_title}>Thank you!</h3>
      <p className={styles.gratitude_description}>
        We will send you an email when new paywalls are published
      </p>

      <img
        className={styles.gratitude_image}
        src="/gallery/man-ok.svg"
        alt="man"
      />
    </div>
  );
};

export default PaywallsGratitude;
